function init() {

  // TODO: how to reset form?
  // https://gravitywiz.com/documentation/gravity-forms-reload-form/?ref=158&campaign=p12337#reload-form-merge-tag

  var toggleDynamicSellSheetsForProductId = function(productId) {
    // var $dynamicSellSheets = $('.populate-sell-sheets').find('.gchoice');
    // var $dynamicSellSheetsForProduct = $dynamicSellSheets.find('span[data-product-id="' + productId + '"]').closest('.gchoice');

    // $dynamicSellSheets.hide();
    // $dynamicSellSheetsForProduct.show();

    // if($dynamicSellSheetsForProduct.length === 1) {
    //   $dynamicSellSheetsForProduct.addClass('active');
    //   $dynamicSellSheetsForProduct.find('input').click();
    //   $dynamicSellSheetsForProduct.find('input').attr('checked', true);
    // }

    var $dynamicSellSheets = $('.populate-sell-sheets').find('.gchoice');
    var $dynamicSellSheetsForProduct = $dynamicSellSheets.find('span[data-product-id="' + productId + '"]').closest('.gchoice');

    $dynamicSellSheets.hide().removeClass('active').find('input').attr('checked', false);

    $dynamicSellSheetsForProduct.show();
    if($dynamicSellSheetsForProduct.length === 1) {
      $dynamicSellSheetsForProduct.addClass('active').find('input').attr('checked', true);
    }
  };

  // add a wrapper class for css background
  var addCheckboxChangeListeners = function() {
    $('.gfield_checkbox').find('.gchoice').each(function() {
      var $control = $(this);
      var $input = $control.find('input'); // 1 input

      if($input.is(':checked')) {
        $control.addClass('active');
      }

      $input.on('change', function() {
        if($input.is(':checked')) {
          $control.addClass('active');
        }
        else {
          $control.removeClass('active');
        }
      });
    });
  };

  // add a wrapper class for css background
  var addRadioChangeListeners = function() {
    $('.gfield_radio').find('.gchoice').each(function() {
      var $control = $(this);
      var $siblings = $control.siblings(); // n siblings
      var $input = $control.find('input'); // 1 input

      if($input.is(':checked')) {
        $control.addClass('active');
      }

      $input.on('change', function() {
        $siblings.removeClass('active');
        if($input.is(':checked')) {
          $control.addClass('active');
        }
        else {
          $control.removeClass('active');
        }
      });
    });
  };

  addRadioChangeListeners($('.custom-radio'));

  // fired every time the form is rendered to allow custom jQuery to be executed
  // e.g. initial form load, going to the next/previous page on multi-page forms, form rendered with validation errors, confirmation message displayed, etc
  $(document).on('gform_post_render', function(event, form_id, current_page) {
    addCheckboxChangeListeners();
    addRadioChangeListeners();
    window.gformProductId && toggleDynamicSellSheetsForProductId(window.gformProductId);
    $('.modal').animate({ scrollTop: 0 }, 300);
    // see also: headroom.js
  });

  // Fires on multi-page forms with AJAX submission enabled when changing pages (i.e. going to the next or previous page).
  // $(document).on('gform_page_loaded', function(event, form_id, current_page) {});

  window.gform && window.gform.addFilter('gform_datepicker_options_pre_init', function(optionsObj, formId, fieldId) {
    optionsObj.minDate = 1; // tomorrow or later
    return optionsObj;
  });

  $('[data-toggle="modal"]').on('click', function() {
    var productId = parseInt($(this).attr('data-product-id'), 10);
    if(!productId) {
      return;
    }

    window.gformProductId = productId;
    toggleDynamicSellSheetsForProductId(productId);
  });

}

export default init;



// WEBPACK FOOTER //
// ./scripts/base/gravityForms.js